import { emailRule, requiredRule } from '@utils/rules'
import { Flex, Form, Input } from 'antd'
import { NamePath } from 'antd/es/form/interface'
import { FC } from 'react'

interface Props {}

const BookingConnectorEmailSection: FC<Props> = ({}) => {
  const formItemName: NamePath = ['booking', 'app', 'connectors', 'email']

  return (
    <Flex vertical style={{ padding: 20 }} gap={16}>
      <Form.Item
        name={formItemName}
        label={'Email'}
        rules={[requiredRule(), emailRule()]}
        required
      >
        <Input size="large" placeholder={'bookings@venue.com'} />
      </Form.Item>
    </Flex>
  )
}

export { BookingConnectorEmailSection }
